module.exports = __webpack_public_path__ + "static/img/s108.491f1420.png";